<template>
	<div v-if="$store.getters['session/isLogged']" @mousemove="reset">
		<slot/>
	</div>
	<div v-else>
		<slot/>
	</div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin'

const MAX_IDLE_MINUTES = 60
const WARNING_IDLE_MINUTES = 55

const I18N_FILE = 'private-layout'

export default {
	mixins: [i18nMixin(I18N_FILE)],
	data () {
		return {
			idleMinutes: 0,
			intervalId: null
		}
	},
	watch: {
		idleMinutes (val) {
			if (val >= MAX_IDLE_MINUTES) {
				this.$router.push('/cuenta/kickout')
				return
			}
			if (val === WARNING_IDLE_MINUTES) {
				this.$store.dispatch('showSharedDialog', { content: this.$t('private-layout.idle-time-warning') })
			}
		}
	},
	created () {
		this.init()
	},
	beforeDestroy () {
		if (this.intervalId) {
			clearInterval(this.intervalId)
		}
	},
	methods: {
		init () {
			if (this.$store.getters['session/isLogged']) {
				this.intervalId = setInterval(() => {
					this.idleMinutes++
				}, MAX_IDLE_MINUTES * 1000)
			}
		},
		reset () {
			this.idleMinutes = 0
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/utils/IdleTracker.vue